module.exports = __webpack_public_path__ + "img/hpb.bbc52ea3.svg";